import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "disabled", "hasError", "hint", "inputProps", "label", "SuffixIcon", "withDivider", "countryList", "countryOnChange", "countryValue", "defaultCountry", "dropdownClassname", "menuPortalTarget", "onChange"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import clsx from 'clsx';
import React, { forwardRef, useRef } from 'react';
var styles = {
  "hint": "pbui-R-8vv",
  "hint--no-error": "pbui-YhGqO",
  "hint--has-error": "pbui-49cjI",
  "label": "pbui-xvGoL",
  "container": "pbui-aT1-T",
  "input__container": "pbui-ui6BX",
  "input__container--disabled": "pbui-ZN8Wm",
  "input__container--has-error": "pbui-AM3ix",
  "dropdown": "pbui-iprEz",
  "input": "pbui-udKM8",
  "input--with-suffix-divider": "pbui-b1EtW",
  "suffix": "pbui-H7ZzL"
};
import { TelInputHint } from './TelInputHint';
import { TelInputLabel } from './TelInputLabel';
import Select from './../Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var allowedCharacters = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
var TelInputField = /*#__PURE__*/forwardRef(function InputField(props, _ref) {
  var className = props.className,
    disabled = props.disabled,
    hasError = props.hasError,
    hint = props.hint,
    inputProps = props.inputProps,
    label = props.label,
    SuffixIcon = props.SuffixIcon,
    withDivider = props.withDivider,
    countryList = props.countryList,
    countryOnChange = props.countryOnChange,
    countryValue = props.countryValue,
    defaultCountry = props.defaultCountry,
    dropdownClassname = props.dropdownClassname,
    menuPortalTarget = props.menuPortalTarget,
    onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  var inputRef = useRef(null);
  var inputContainerClasses = clsx(styles.input__container, className, disabled && styles['input__container--disabled'], hasError && styles['input__container--has-error']);
  var dropdownClasses = clsx(styles.dropdown, dropdownClassname);
  var inputClasses = clsx(styles.input, inputProps == null ? void 0 : inputProps.className, SuffixIcon && withDivider && styles['input--with-suffix-divider']);
  var suffixClasses = clsx(styles.suffix);
  var handleIconClick = function handleIconClick() {
    var node = inputRef.current;
    if (node !== null) node.focus();
  };
  var handlePhoneInputChange = function handlePhoneInputChange(e) {
    var copyOfValue = e.target.value;
    var newValue = '';
    var _iterator = _createForOfIteratorHelper(copyOfValue),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var character = _step.value;
        if (allowedCharacters.includes(character)) {
          newValue += character;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    e.target.value = newValue;
    if (onChange) onChange(e);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [label && /*#__PURE__*/_jsx(TelInputLabel, {
      htmlFor: rest.id,
      className: inputProps == null ? void 0 : inputProps.labelClassName,
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: inputContainerClasses,
      children: [/*#__PURE__*/_jsx(Select, {
        noBorder: true,
        options: countryList,
        onChange: function onChange(option) {
          return countryOnChange(option);
        },
        value: countryValue,
        defaultValue: defaultCountry,
        className: dropdownClasses,
        menuPortalTarget: menuPortalTarget,
        isDisabled: disabled
      }), /*#__PURE__*/_jsx("input", _extends({
        type: "tel",
        ref: function ref(element) {
          inputRef.current = element;
          if (typeof _ref === "function") {
            _ref(element);
          } else if (_ref) {
            _ref.current = element;
          }
        },
        className: inputClasses,
        disabled: disabled,
        inputMode: "numeric",
        onChange: handlePhoneInputChange,
        autoComplete: "one-time-code"
      }, rest)), SuffixIcon && /*#__PURE__*/_jsx("span", {
        className: suffixClasses,
        onClick: function onClick() {
          return handleIconClick();
        },
        children: SuffixIcon()
      })]
    }), hint && /*#__PURE__*/_jsx(TelInputHint, {
      hasError: hasError,
      children: hint
    })]
  });
});
export default TelInputField;